import { Navigate } from '@tanstack/react-router';
import { StructurePanel } from '@/pages/structure/StructurePanel';
import { TeamPanel } from '@/pages/team/TeamPanel';
import { RolesPanel } from '@/pages/company/roles/RolesPanel';
import { CompanyReferencePanel } from '@/pages/company/reference/CompanyReferencePanel';
import { CompanyLayout } from './CompanyLayout';
import { CompanyLanding } from './CompanyLanding';
import { CompanyProfileTab } from './CompanyProfileTab';
import { IntegrationsTab } from './IntegrationsTab';
import { SeasonSettingsTab } from './SeasonSettingsTab';
import { COMPANY_TAB_KEYS } from './companyTabs';

/**
 * /company — раздел «Управление компанией» (AK-350).
 *
 * Единый хаб админ-фич: Структура · Команда · Роли и доступы · Справочники ·
 * Интеграции · Профиль. Вкладка = сегмент URL (/company/<tab>). /company (index)
 * — обзорный лендинг с карточками-саммари.
 *
 * Гейт по admin-роли — как у /team — в Sidebar (пункт скрыт не-админам).
 * Финальную проверку прав на действия делает бэк (require_structure_write /
 * _require_can_manage) — при 403 панели показывают сообщение.
 */

/** Контент вкладки по ключу. null → лендинг. */
function TabContent({ tab }: { tab: string | null }) {
  switch (tab) {
    case null:
      return <CompanyLanding />;
    case 'structure':
      return <StructurePanel showHeader={false} />;
    case 'team':
      return <TeamPanel showHeader={false} />;
    case 'profile':
      return <CompanyProfileTab />;
    case 'roles':
      return <RolesPanel />;
    case 'reference':
      // AK-527: вкладка стала контейнером тенантских справочников
      // (культуры + типы операций), а не одним экраном культур.
      return <CompanyReferencePanel />;
    case 'season':
      return <SeasonSettingsTab />;
    case 'integrations':
      // AK-738: статус-борд синхры AgroHistory. 1С/Bitrix24 — заглушка внутри.
      return <IntegrationsTab />;
    default:
      return null;
  }
}

/** /company (index) — лендинг-обзор. */
export function CompanyPage() {
  return (
    <CompanyLayout activeTab={null}>
      <TabContent tab={null} />
    </CompanyLayout>
  );
}

/** /company/$tab — конкретная вкладка. Неизвестный tab → редирект на /company. */
export function CompanyTabPage({ tab }: { tab: string }) {
  if (!COMPANY_TAB_KEYS.includes(tab)) {
    return <Navigate to="/company" replace />;
  }
  return (
    <CompanyLayout activeTab={tab}>
      <TabContent tab={tab} />
    </CompanyLayout>
  );
}

export default CompanyPage;
